import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-form" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "input-wr short" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("label", { class: "label" }, "Add Site Costs", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            placeholder: "Site Costs",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.siteCostsSelected) = $event)),
            type: "number"
          }, null, 512), [
            [_vModelText, $setup.siteCostsSelected]
          ])
        ])
      ])
    ])
  ]))
}